import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=fc40329a"
import script from "@/controllers/custom/chat/request-list.js?vue&type=script&lang=js&external"
export * from "@/controllers/custom/chat/request-list.js?vue&type=script&lang=js&external"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=fc40329a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports